import type { BlobLike, ImageArray } from "@pdfking/compatibility"
import { BlobCreate } from "@pdfking/compatibility"

const toImageData = (image: ImageArray): ImageData =>
  new ImageData(new Uint8ClampedArray(image.data), image.width, image.height)

export const ExportImage = async (
  image: ImageArray,
  type: "image/jpeg" | "image/png" | "image/webp" = "image/webp"
): Promise<BlobLike> => {
  const imageData = toImageData(image)

  if (typeof OffscreenCanvas !== "undefined") {
    const canvas = new OffscreenCanvas(imageData.width, imageData.height)
    const ctx = canvas.getContext("2d")
    if (!ctx) throw new Error("Failed to get canvas 2d context")
    ctx.putImageData(imageData, 0, 0)
    return canvas
      .convertToBlob({
        type,
      })
      .then(b => BlobCreate(b, type))
  }

  if (typeof document !== "undefined") {
    const canvas = document.createElement("canvas")
    canvas.width = imageData.width
    canvas.height = imageData.height
    const ctx = canvas.getContext("2d")
    if (!ctx) throw new Error("Failed to get canvas 2d context")
    ctx.putImageData(imageData, 0, 0)

    return new Promise((resolve, reject) => {
      canvas.toBlob(blob => {
        if (blob) {
          resolve(BlobCreate(blob, blob.type))
        } else {
          reject(new Error("Failed to create blob from canvas"))
        }
      }, type)
    })
  }

  throw new Error("No canvas implementation available")
}
